module.exports = __webpack_public_path__ + "static/26ff834162971c78324a5e404f56ab234f514c955af0a850778e857905d93c13-e7d32f70840429fa9f4fc0a7310eb971.png";